import React, { createContext, useContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./initialState";
import { getDocs } from "../hooks/getDocs";
import { condition } from "./condition";
import { getCacheDocs } from "../hooks/getCacheDocs";
import { getLogs } from "AdminSection/hooks/getLogs";
import { getErrorLogs } from "AdminSection/hooks/errorLogsData";
const AppContext = createContext();

const AdminContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const fetchErrorLogs = async (payload) => {
    try {
      const data = await getErrorLogs(payload);
      console.log(data, 'data');
      dispatch({ type: condition.ERROR_LOGS_DATA, payload: data });
    } catch (err) {
      console.log("Error: ", err);
    }
  };
  const fetchLogs = async (payload) => {
    try {
      const data = await getLogs(payload);
      console.log(data, 'data');
      dispatch({ type: condition.LOGS_DATA, payload: data });
    } catch (err) {
      console.log("Error: ", err);
    }
  };
  const fetchDocuments = async (activeTab) => {
    try {
      const data = await getDocs(activeTab);
      let pdfData = [];
      let urlData = [];
      data?.docs?.forEach((doc) => {
        if (/\.pdf|\/media\//.test(doc.name)) {
          pdfData.push(doc);
        } else if (doc.name.startsWith("https://")) {
          urlData.push(doc);
        } else {
          urlData.push(doc);
        }
      });
      dispatch({ type: condition.URL_DATA, payload: urlData });
      dispatch({ type: condition.PDF_DATA, payload: pdfData });
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const fetchCacheDocs = async (cacheName, activeTab) => {
    try {
      const data = await getCacheDocs(cacheName, activeTab);
      switch (cacheName) {
        case "text_qna": {
          dispatch({ type: condition.CACHE_TEXT_QNA, payload: data.docs });
          return;
        }
        case "mutual_fund": {
          dispatch({ type: condition.CACHE_MUTUAL_FUND, payload: data.docs });
          return;
        }
        case "greeting": {
          dispatch({ type: condition.CACHE_GREETING, payload: data.docs });
          return;
        }
        case "bing_qna": {
          dispatch({ type: condition.CACHE_BING_QNA, payload: data.docs });
          return;
        }
        default: { }
      }
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  return (
    <AppContext.Provider
      value={{
        fetchDocuments,
        fetchCacheDocs,
        fetchLogs,
        fetchErrorLogs,
        state,
        dispatch,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
const Globalstate = () => useContext(AppContext);

export { AdminContext, Globalstate, AppContext };